module.exports = __webpack_public_path__ + "static/media/messages.d621ff11.png";